import { Record } from 'immutable';
export default Record({
  type: 'NONE'
});